import { render, staticRenderFns } from "./ChartBrandArtistRank.vue?vue&type=template&id=16745ad6&scoped=true"
import script from "./ChartBrandArtistRank.vue?vue&type=script&lang=js"
export * from "./ChartBrandArtistRank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16745ad6",
  null
  
)

export default component.exports